<!--
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-06-05 16:14:07
 * @LastEditors: 'lek' '2889356275@qq.com'
 * @LastEditTime: 2025-06-05 16:14:27
 * @FilePath: \HTML和CSSe:\巴斯德\公司网站\bsd_website\src\components\BackToTop.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div 
    class="back-to-top" 
    :class="{ visible: visible }" 
    @click="scrollToTop"
  >
    <span>↑</span>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > 300; // 滚动超过300px显示按钮
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: #00D4B4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top.visible {
  opacity: 1;
  transform: translateY(0);
}

.back-to-top:hover {
  background: #00B8A3;
  transform: translateY(-3px);
}
</style>